import defaultTheme from './variants/theme'

const themes = {
  default: defaultTheme,
}

const getTheme = (variant = 'default') => themes[variant]

export default getTheme
